import React from "react";
import { type BoxProps, Text } from "@chakra-ui/react";
import { ChakraBox } from "ui/chakra-framer";

export function HeadingText({ isFirstLoop = false, children }: BoxProps & { isFirstLoop?: boolean }) {
  return (
    <ChakraBox
      position="absolute"
      inset={0}
      display="flex"
      alignItems="center"
      h="100%"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0, transition: { duration: 0.35, delay: isFirstLoop ? 0.8 : 0.5 } }}
      exit={{
        opacity: 0,
        y: 20,
        transition: {
          duration: 0.35,
        },
      }}
    >
      <Text fontWeight="semibold" fontSize={{ base: "sm", md: "base", lg: "lg" }}>
        {children}
      </Text>
    </ChakraBox>
  );
}
